import React from 'react';
import { motion } from 'framer-motion';
export function Problem() {
  return <section className="py-12 md:py-14 bg-white" data-id="element-194">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl text-center" data-id="element-195">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-196">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-navy mb-8" data-id="element-197">
            Esa pesadez no es tu culpa, pero{' '}
            <span className="text-brand-gold" data-id="element-198">te está robando la energía.</span>
          </h2>

          <div className="prose prose-lg mx-auto text-gray-700 leading-relaxed" data-id="element-199">
            <p className="mb-6" data-id="element-200">
              Has intentado dejar el pan, has tomado batidos verdes que saben a
              pasto y has pasado horas en el gimnasio, pero la "guatita" sigue
              ahí.
            </p>
            <p className="mb-6 font-medium text-brand-navy text-xl" data-id="element-201">
              Esa pesadez no solo afecta cómo te ves en el espejo, sino que te
              quita la energía para jugar con tus hijos o rendir en el trabajo.
            </p>
            <p data-id="element-202">
              Te sientes pesada, cansada y frustrada porque parece que nada de
              lo que haces funciona.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}